var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.5C1.5 6.014 3.538 4 6.054 4h.303c.672 0 1.214.536 1.214 1.2 0 .664-.542 1.2-1.214 1.2h-.303c-1.173 0-2.125.941-2.125 2.1v.3h2.428c1.34 0 2.429 1.076 2.429 2.4v2.4c0 1.324-1.09 2.4-2.429 2.4H3.93C2.589 16 1.5 14.924 1.5 13.6V8.5Zm9.714 0c0-2.486 2.038-4.5 4.554-4.5h.303c.672 0 1.215.536 1.215 1.2 0 .664-.543 1.2-1.215 1.2h-.303c-1.173 0-2.125.941-2.125 2.1v.3h2.428c1.34 0 2.429 1.076 2.429 2.4v2.4c0 1.324-1.09 2.4-2.429 2.4h-2.428c-1.34 0-2.429-1.076-2.429-2.4V8.5Z",
    fill: "#D7A100"
  })));
};
export default SvgQuote;